
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/go-ers",
      function () {
        return require("private-next-pages/go-ers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/go-ers"])
      });
    }
  